import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { useAppDispatch } from "../../store";
import { SessionCheckFailure } from "../shared/interfaces/auth-state";
import { resetAutoSignIn, startAutoSignIn } from "../shared/start-sign-in";
import {
  getIsAuthenticated,
  getLoadingUserDto,
  getSessionCheckFailure,
} from "../store/auth.selector";
import { initializeAuth } from "../store/auth.slice";

export function useAuthGate(): {
  isAuthenticated: boolean;
  isLoadingUserDto: boolean;
  sessionCheckFailure: SessionCheckFailure | null;
  isSignInLooped: boolean;
  retry: () => void;
} {
  const isAuthenticated = useSelector(getIsAuthenticated);
  const isLoadingUserDto = useSelector(getLoadingUserDto);
  const sessionCheckFailure = useSelector(getSessionCheckFailure);
  const dispatch = useAppDispatch();
  const authCheckStarted = useRef(false);
  const [isSignInLooped, setSignInLooped] = useState(false);

  const checkSession = useCallback(() => {
    authCheckStarted.current = true;
    setSignInLooped(false);
    dispatch(initializeAuth()).then((action) => {
      if (!initializeAuth.fulfilled.match(action)) {
        return;
      }
      if (action.payload.isValid) {
        resetAutoSignIn();
      } else if (!startAutoSignIn(window.location.href)) {
        setSignInLooped(true);
      }
    });
  }, [dispatch]);

  useEffect(() => {
    if (isAuthenticated || authCheckStarted.current || isLoadingUserDto) {
      return;
    }
    checkSession();
  }, [isAuthenticated, isLoadingUserDto, checkSession]);

  return {
    isAuthenticated,
    isLoadingUserDto,
    sessionCheckFailure,
    isSignInLooped,
    retry: checkSession,
  };
}
